import { useEffect } from 'react';
import { useRouter } from 'next/router';
import '@/shared/logger';
import { logger } from '@zep/core-logger';
import { useLocale } from '@/shared/hooks/useLocale';
export const AuthAppLoggerInitializer = () => {
  const router = useRouter();
  const {
    locale
  } = useLocale();
  useEffect(() => {
    if (!router.isReady) return;
    const state: Record<string, string> = {
      locale
    };
    const service = router.query.service;
    const deviceId = router.query.deviceId;
    if (typeof service === 'string') state.service = service;
    // 호출 서비스(quiz-app, web-app 등)에서 전달한 deviceId를 logger state로 주입하여
    // auth-app의 모든 후속 이벤트가 호출 서비스의 zepDeviceId 키로 조인 가능하도록 한다.
    if (typeof deviceId === 'string') state.zepDeviceId = deviceId;
    logger.setState(state);
  }, [router.isReady, router.query.service, router.query.deviceId, locale]);
  return null;
};